export default __webpack_public_path__ + "static/media/icomoon.185cd8f5.ttf";